import Vue from 'vue';
import App from './App.vue';
import '@progress/kendo-theme-default/dist/all.css';
import VueI18n from 'vue-i18n';
import messages from './lang';
import router from './router';
import FlagIcon from 'vue-flag-icon';
import { ScrollView, ScrollViewInstaller } from '@progress/kendo-scrollview-vue-wrapper';

Vue.config.productionTip = true;

Vue.use(VueI18n);
Vue.use(FlagIcon);
Vue.use(ScrollViewInstaller);

export const i18n = new VueI18n({
    locale: 'de',
    fallbackLocale: 'de',
    messages
});

new Vue({
    i18n,
    router,
    ScrollView,
    render: h => h(App)
}).$mount('#app');
